export function clientCurrentStatus(clientIsDeceased, seatStatus) {
  if (clientIsDeceased)
    return 'Deceased'

  if (seatStatus === 'Denied')
    return 'Request denied'

  return seatStatus
}
